import React from "react";
import { getStorageItem, setStorageItem, StorageKey } from "../utils/localStorage.util";

export interface UseRpiPerPageProps {
  id?: string;
  perPage: number;
}

export interface UseRpiPerPageResult {
  perPage: number;
  setPerPage: (perPage: number) => void;
}

export function useRpiPerPage({ id, perPage: initialPerPage }: UseRpiPerPageProps): UseRpiPerPageResult {
  const [perPage, setPerPage] = React.useState<number>(() => {
    const initialValue = initialPerPage || 10;
    if (!id) return initialValue;

    const storage = getStorageItem<Record<string, number>>(StorageKey.RPI_PER_PAGE);
    if (!storage || !storage[id]) return initialValue;

    return storage[id];
  });

  const handleSetPerPage: UseRpiPerPageResult["setPerPage"] = React.useCallback(
    (newPerPage) => {
      setPerPage(newPerPage);

      if (!id) return;

      const storage = getStorageItem<Record<string, number>>(StorageKey.RPI_PER_PAGE) || {};
      storage[id] = newPerPage;

      setStorageItem(StorageKey.RPI_PER_PAGE, storage);
    },
    [id]
  );

  return {
    perPage,
    setPerPage: handleSetPerPage,
  };
}
